import '../../css/misc/contactform.css';
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Col, Row } from 'react-bootstrap';
import SignalRService from '../../controllers/SignalRService';
import { changeJanusStatus } from '../../redux/parametersSlice';
import { notify } from '../utils/utils';

class ContactFormCall extends Component {

    constructor(props) {
        super(props);
        this.handleMessage = this.handleMessage.bind(this);
        this.state = {
            closedForm: ""
        }
    }

    componentDidMount() {
        window.addEventListener("message", this.handleMessage);
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.handleMessage);
    }

    componentDidUpdate(prevProps, prevState) {

        if (this.props.functions !== null && this.props.form !== null && this.props.form.length > 0 && this.props.form !== prevProps.form) {

            if (this.props.form.indexOf("/FidelityForms") === -1)
                window.open(this.props.form);

            if ((this.props.form.indexOf("incoming") !== -1 && this.props.functions.popupOutgoingCamp === 2) ||
                (this.props.form.indexOf("preview") !== -1 && [1, 2].indexOf(this.props.functions.popupOutgoingCamp) > -1)) {

                let dateTime = new Date().toLocaleString();
                let partyName = this.props.partyName ? this.props.partyName : this.props.t("unknown")
                let notificationBody = this.props.groupName + " " + dateTime + "\n" + this.props.party + "\n" + partyName;
                notify("Fidelity Agent: " + this.props.t("form"), notificationBody, `${window.location.origin}${window.location.pathname}/favicon.ico`, "camp");
            }
        }
    }
    
    shouldComponentUpdate(nextProps) {
        return nextProps.form !== this.props.form;
    }

    handleMessage(event) {
        console.log("ContactFormCall handleMessage: ", event.data);

        if (event.data.Method === "MakeCallCampRemote") {
            this.props.changeJanusStatus("makeCall");
            SignalRService.makeCallCamp({
                "extension": this.props.extension,
                "userId": this.props.userId,
                "called": event.data.Called,
                "prefix": event.data.Prefix
            });
        }

        if (event.data.Method === "SetFormChange" && event.data.Status === "CLOSE") {

            SignalRService.setFormChange({
                "extension": this.props.extension,
                "userId": this.props.userId,
                "status": event.data.Status
            });

            this.setState({
                closedForm: this.props.form
            });

            setTimeout(() => {
                console.log("closedForm: " + this.state.closedForm);
                console.log("form: " + this.props.form);
                if (this.state.closedForm === this.props.form)
                    this.props.hideFormUrl();
            }, 5000);
        }
    }

    render() {
        return (
            <Row>
                <Col style={{ height: "74vh" }}>
                    <iframe title="contacts" src={`${this.props.form}`} width={"100%"} height={"100%"}></iframe>
                </Col>
            </Row>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        extension: state.agent.extension,
        userId: state.agent.userId,
        party: state.agent.party,
        partyName: state.agent.partyName,
        groupName: state.agent.groupName,
        functions: state.agent.functions
    };
};

export default compose(connect(mapStateToProps, { changeJanusStatus }), withTranslation())(ContactFormCall);